module.exports = __webpack_public_path__ + "img/mafia_wars_two.c95b9ee7.jpg";